var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeeLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.113 270.455C178.811 224.075 242.668 181.298 297.992 215.94C304.883 220.254 314.779 228.618 316.462 236.906C325.434 281.055 219.899 337.713 168.712 307.497C164.995 305.3 145.854 281.143 143.853 281.636C137.464 283.209 118.718 290.291 114.019 294.914C113.573 295.353 132.91 288.624 150.246 288.624",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.543 237.122C205.369 258.398 200.625 296.531 200.625 311.775",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.193 220.22C239.777 244.764 237.816 272.365 232.076 297.689",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.838 251.531C284.957 252.267 284.477 252.976 284.297 253.7",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.398 191.049C218.251 170.409 164.043 73.6845 139.078 86.0953C118.061 96.542 179.056 165.553 186.868 173.32C193.432 179.846 212.414 199.306 208.263 191.049C202.171 178.929 175.365 166.868 164.043 161.975C63.9156 118.688 52.5083 209.528 152.632 194.597C167.952 192.312 183.247 188.576 198.279 186.085",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeLeft);
export default __webpack_public_path__ + "static/media/bee-left.2683ec7115a0ba7e1d0b87e3d5cc70ea.svg";
export { ForwardRef as ReactComponent };